import { i18n_config_default } from './chunk-SGCJ7UYI.mjs';

// src/helpers/factories/menu/categoriesFactory.ts
var categoriesDropdownOptionsFactoryCore = (categoryIds, categories, showNoCategoryOption = false) => {
  const options = categoryIds.filter((categoryId) => categoryId > 0).map((categoryId) => {
    const category = categories[categoryId];
    return {
      value: category.categoryId,
      label: category.name
    };
  });
  return showNoCategoryOption ? [
    {
      value: 0,
      label: i18n_config_default.t(
        "menuScreen.categoryDetails.associations.subcategories.noCategory"
      )
    },
    ...options
  ] : options;
};

export { categoriesDropdownOptionsFactoryCore };
